var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticsTreeLeafIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65178 63C4.43314 60.3353 5.95018 56.29 8.19592 51.748M63 4.52664C60.8252 10.3473 56.3123 23.9563 55.6599 31.8265C54.8443 41.6643 50.2019 51.994 39.9132 55.9906C31.6822 59.1879 15.3388 54.4944 8.19592 51.748M63 4.52664C27.2404 -1.92941 6.53763 13.4421 3.65178 25.3705C1.34309 34.9131 5.71925 46.9316 8.19592 51.748M63 4.52664C57.3582 7.56179 45.962 14.1703 35.5348 21.4353M8.19592 51.748C10.3835 47.3238 13.2624 42.4283 16.8264 37.8786M16.8264 37.8786C19.1999 34.8486 21.8773 31.972 24.8565 29.49C28.0713 26.812 31.7388 24.0801 35.5348 21.4353M16.8264 37.8786C15.7599 35.0619 14.5052 27.8299 18.0184 21.4353M16.8264 37.8786C19.775 39.6119 27.6797 42.6604 35.7099 40.988M34.7689 11.659C34.2966 14.3849 33.7886 20.1564 35.5348 21.4353M35.5348 21.4353C37.9543 23.698 43.9789 23.7718 46.6887 23.5259",
    stroke: "#1347D7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsTreeLeafIcon);
export default __webpack_public_path__ + "static/media/statisticsTreeLeafIcon.7685aca6f4d3bd6d2ec89c59cda68593.svg";
export { ForwardRef as ReactComponent };